import { showArticle } from '@intercom/messenger-js-sdk'

export const openIntercomArticle = (articleId: string): void => {
  showArticle(articleId)
}
